import { match } from 'ts-pattern';
import { z } from 'zod';

// Plan categories - ES

export const B2bPlanCategoryEsPeiValues = ['PEI', 'PEE', 'PEEG'] as const;
export const ZodB2bPlanCategoryEsPei = z.enum(B2bPlanCategoryEsPeiValues);
export type B2bPlanCategoryEsPei = z.infer<typeof ZodB2bPlanCategoryEsPei>;

export const B2bPlanCategoryEsPerecoiValues = [
  'PERECOI',
  'PERECO',
  'PERECOG',
  'PERCOI',
  'PERCO',
] as const;
export const ZodB2bPlanCategoryEsPerecoi = z.enum(B2bPlanCategoryEsPerecoiValues);
export type B2bPlanCategoryEsPerecoi = z.infer<typeof ZodB2bPlanCategoryEsPerecoi>;

export const B2bPlanCategoryEsValues = [
  ...B2bPlanCategoryEsPeiValues,
  ...B2bPlanCategoryEsPerecoiValues,
] as const;
export const ZodB2bPlanCategoryEs = z.enum(B2bPlanCategoryEsValues);
export type B2bPlanCategoryEs = z.infer<typeof ZodB2bPlanCategoryEs>;

// Plan categories - ER

export const B2bPlanCategoryErTaigaValues = [
  'PERO',
  'PERU',
  'PER',
  'ARTICLE_82',
  'ARTICLE_83',
  'PERECOER',
] as const;
export const ZodB2bPlanCategoryErTaiga = z.enum(B2bPlanCategoryErTaigaValues);
export type B2bPlanCategoryErTaiga = z.infer<typeof ZodB2bPlanCategoryErTaiga>;

export const B2bPlanCategoryErExternalValues = ['ER_EXTERNAL'] as const;
export const ZodB2bPlanCategoryErExternal = z.enum(B2bPlanCategoryErExternalValues);
export type B2bPlanCategoryErExternal = z.infer<typeof ZodB2bPlanCategoryErExternal>;

export const B2bPlanCategoryErValues = [
  ...B2bPlanCategoryErTaigaValues,
  ...B2bPlanCategoryErExternalValues,
] as const;
export const ZodB2bPlanCategoryEr = z.enum(B2bPlanCategoryErValues);
export type B2bPlanCategoryEr = z.infer<typeof ZodB2bPlanCategoryEr>;

// Plan categories - All

export const B2bSavingPlanCategoryValues = [
  ...B2bPlanCategoryEsValues,
  ...B2bPlanCategoryErValues,
] as const;
export const ZodB2bSavingPlanCategory = z.enum(B2bSavingPlanCategoryValues);
export type B2bSavingPlanCategory = z.infer<typeof ZodB2bSavingPlanCategory>;

// Plan types - ES

export const B2bPlanTypeEsPeiLibreValues = ['PEI_LIBRE', 'PEE_LIBRE', 'PEEG_LIBRE'] as const;

export const B2bPlanTypeTransferBretonSourceValues = ['PEE_LIBRE', 'PEI_LIBRE'] as const;
export const B2bPlanTypeTransferBretonDestinationValues = ['PERCO_LIBRE', 'PERCOI_LIBRE'] as const;

export const B2bPlanTypeEsPeiProfileValues = [
  'PEI_PROFILE',
  'PEE_PROFILE',
  'PEEG_PROFILE',
] as const;
export const ZodB2bPlanTypeEsPeiProfileValues = z.enum(B2bPlanTypeEsPeiProfileValues);
export type B2bPlanTypeEsPeiProfile = z.infer<typeof ZodB2bPlanTypeEsPeiProfileValues>;

export const B2bPlanTypeEsPerecoiLibreValues = [
  'PERECOI_LIBRE',
  'PERECO_LIBRE',
  'PERECOG_LIBRE',
  'PERCOI_LIBRE',
  'PERCO_LIBRE',
] as const;

export const B2bPlanTypeEsPerecoiPiloteValues = [
  'PERECOI_PILOTE',
  'PERECO_PILOTE',
  'PERECOG_PILOTE',
  'PERCOI_PILOTE',
  'PERCO_PILOTE',
] as const;
export const ZodB2bPlanTypeEsPerecoiPiloteValues = z.enum(B2bPlanTypeEsPerecoiPiloteValues);
export type B2bPlanTypeEsPerecoiPilote = z.infer<typeof ZodB2bPlanTypeEsPerecoiPiloteValues>;

export const B2bPlanTypeEsPeiValues = [
  ...B2bPlanTypeEsPeiLibreValues,
  ...B2bPlanTypeEsPeiProfileValues,
] as const;
export const ZodB2bPlanTypeEsPeiValues = z.enum(B2bPlanTypeEsPeiValues);
export type B2bPlanTypeEsPei = z.infer<typeof ZodB2bPlanTypeEsPeiValues>;

export const B2bPlanTypeEsPerecoiValues = [
  ...B2bPlanTypeEsPerecoiLibreValues,
  ...B2bPlanTypeEsPerecoiPiloteValues,
] as const;

// Pre-PACTE plans of the PERECO family: their voluntary payments are never income-tax deductible.
export const B2bPlanTypeEsPercoiValues = [
  'PERCO_LIBRE',
  'PERCO_PILOTE',
  'PERCOI_LIBRE',
  'PERCOI_PILOTE',
] as const;

export const B2bPlanTypeEsLibreValues = [
  ...B2bPlanTypeEsPeiLibreValues,
  ...B2bPlanTypeEsPerecoiLibreValues,
] as const;
export type B2bPlanTypeEsLibre = (typeof B2bPlanTypeEsLibreValues)[number];

export const B2bPlanTypeEsPiloteValues = [
  ...B2bPlanTypeEsPeiProfileValues,
  ...B2bPlanTypeEsPerecoiPiloteValues,
] as const;
export type B2bPlanTypeEsPilote = (typeof B2bPlanTypeEsPiloteValues)[number];

export const B2bPlanTypeEsValues = [
  ...B2bPlanTypeEsPeiValues,
  ...B2bPlanTypeEsPerecoiValues,
] as const;
export const ZodB2bPlanTypeEs = z.enum(B2bPlanTypeEsValues);
export type B2bPlanTypeEs = (typeof B2bPlanTypeEsValues)[number];

// Plan types - ER

export const B2bPlanTypeErLibreValues = [
  'PERO_LIBRE',
  'PERU_LIBRE',
  'PER_LIBRE',
  'ARTICLE_82_LIBRE',
  'ARTICLE_83_LIBRE',
  'PERECOER_LIBRE',
] as const;

export const B2bPlanTypeErPiloteValues = [
  'PERO_PILOTE',
  'PERU_PILOTE',
  'PER_PILOTE',
  'ARTICLE_82_PILOTE',
  'ARTICLE_83_PILOTE',
  'PERECOER_PILOTE',
] as const;
export type B2bPlanTypeErPilote = (typeof B2bPlanTypeErPiloteValues)[number];

export const B2bPlanTypeErValues = [
  ...B2bPlanTypeErLibreValues,
  ...B2bPlanTypeErPiloteValues,
] as const;
export type B2bPlanTypeEr = (typeof B2bPlanTypeErValues)[number];
export const B2bPlanTypeErTaigaValues = [...B2bPlanTypeErValues] as const;
export type B2bPlanTypeErTaiga = (typeof B2bPlanTypeErTaigaValues)[number];

export const B2bPlanTypeErExternalValues = ['ER_EXTERNAL'] as const;
export type B2bPlanTypeErExternal = (typeof B2bPlanTypeErExternalValues)[number];

// Plan types - All

export const B2bPlanTypeLibreValues = [
  ...B2bPlanTypeEsLibreValues,
  ...B2bPlanTypeErLibreValues,
] as const;
export const ZodB2bSavingPlanTypeLibre = z.enum(B2bPlanTypeLibreValues);
export type B2bSavingPlanTypeLibre = z.infer<typeof ZodB2bSavingPlanTypeLibre>;
export const B2bPlanTypePiloteValues = [
  ...B2bPlanTypeEsPiloteValues,
  ...B2bPlanTypeErPiloteValues,
] as const;
export const ZodB2bSavingPlanTypeManaged = z.enum(B2bPlanTypePiloteValues);
export type B2bSavingPlanTypeManaged = z.infer<typeof ZodB2bSavingPlanTypeManaged>;

export const B2bSavingPlanTypeValues = [
  ...B2bPlanTypeEsValues,
  ...B2bPlanTypeErValues,
  ...B2bPlanTypeErExternalValues,
] as const;
export const ZodB2bSavingPlanType = z.enum(B2bSavingPlanTypeValues);
export type B2bSavingPlanType = z.infer<typeof ZodB2bSavingPlanType>;

// Others

export const b2bSavingPlanCategoryCustomProductValues = [
  'PEI',
  'PEE',
  'PEEG',
  'PERECOI',
  'PERECO',
  'PERECOG',
  'PERCO',
  'PERCOI',
  'PERO',
  'PERU',
  'PERECOER',
] as const satisfies readonly B2bSavingPlanCategory[];

const ZodB2bSavingPlanCategoryCustomProduct = z.enum(b2bSavingPlanCategoryCustomProductValues);
export type B2bSavingPlanCategoryCustomProduct = z.infer<
  typeof ZodB2bSavingPlanCategoryCustomProduct
>;

// Plans categories which are not allowed to be created from BO, but only from API in context of migration
export const B2bPlanCategoryForbiddenBoCreationValues = [
  'PERCOI',
  'PERCO',
] as const satisfies readonly B2bSavingPlanCategory[];

export const B2bSavingPlanDeductibilityValues = ['non_deductible', 'deductible'] as const;
export const ZodB2bSavingPlanDeductibility = z.enum(B2bSavingPlanDeductibilityValues);
export type B2bSavingPlanDeductibility = z.infer<typeof ZodB2bSavingPlanDeductibility>;

export const B2bSavingPlanDeductibilityName: Record<B2bSavingPlanDeductibility, string> = {
  non_deductible: 'Non Déductible',
  deductible: 'Déductible',
};

export const B2BPortfolioCompanyPlanTypeValues = [
  ...B2bSavingPlanTypeValues,
  ...B2bSavingPlanCategoryValues,
] as const;
export const ZodB2BPortfolioCompanyPlanType = z.enum(B2BPortfolioCompanyPlanTypeValues);
export type B2BPortfolioCompanyPlanType = z.infer<typeof ZodB2BPortfolioCompanyPlanType>;

// Plans deductibility

export const ONLY_DEDUCTIBLE_B2B_CATEGORIES = [
  'ARTICLE_83',
] as const satisfies B2bSavingPlanCategory[];

// PERCO / PERCOI are pre-PACTE plans: their voluntary payments are never deductible (MIKE-14365).
export const ONLY_NON_DEDUCTIBLE_B2B_CATEGORIES = [
  'PERCO',
  'PERCOI',
  'ARTICLE_82',
] as const satisfies B2bSavingPlanCategory[];

export const SELECTABLE_DEDUCTIBLE_B2B_CATEGORIES = [
  'PERECOI',
  'PERECO',
  'PERECOG',
  'PER',
  'PERO',
  'PERU',
  'PERECOER',
] as const satisfies B2bSavingPlanCategory[];

// Helpers

export function isFullyManagedPlan(
  planType: B2bSavingPlanType,
): planType is B2bPlanTypeEsPilote | B2bPlanTypeErPilote | B2bPlanTypeErExternal {
  return (
    (B2bPlanTypePiloteValues as readonly B2bSavingPlanType[]).includes(planType) ||
    (B2bPlanTypeErExternalValues as readonly B2bSavingPlanType[]).includes(planType)
  );
}

export const isPlanLibre = (planType: B2bSavingPlanType) =>
  (B2bPlanTypeLibreValues as readonly B2bSavingPlanType[]).includes(planType);

export const isPerecoiPilotePlan = (
  planType: B2bSavingPlanType,
): planType is B2bPlanTypeEsPerecoiPilote =>
  (B2bPlanTypeEsPerecoiPiloteValues as readonly B2bSavingPlanType[]).includes(planType);

export const b2bCompanyPlanTypeToCategory = (
  type: B2BPortfolioCompanyPlanType,
): B2bSavingPlanCategory => {
  return match(type)
    .returnType<B2bSavingPlanCategory>()
    .with('PEI', 'PEI_LIBRE', 'PEI_PROFILE', () => 'PEI')
    .with('PEE', 'PEE_LIBRE', 'PEE_PROFILE', () => 'PEE')
    .with('PEEG', 'PEEG_LIBRE', 'PEEG_PROFILE', () => 'PEEG')
    .with('PERECOI', 'PERECOI_LIBRE', 'PERECOI_PILOTE', () => 'PERECOI')
    .with('PERECO', 'PERECO_LIBRE', 'PERECO_PILOTE', () => 'PERECO')
    .with('PERECOG', 'PERECOG_LIBRE', 'PERECOG_PILOTE', () => 'PERECOG')
    .with('PERCOI', 'PERCOI_LIBRE', 'PERCOI_PILOTE', () => 'PERCOI')
    .with('PERCO', 'PERCO_LIBRE', 'PERCO_PILOTE', () => 'PERCO')
    .with('PERO', 'PERO_LIBRE', 'PERO_PILOTE', () => 'PERO')
    .with('PERU', 'PERU_LIBRE', 'PERU_PILOTE', () => 'PERU')
    .with('PER', 'PER_LIBRE', 'PER_PILOTE', () => 'PER')
    .with('ARTICLE_83', 'ARTICLE_83_LIBRE', 'ARTICLE_83_PILOTE', () => 'ARTICLE_83')
    .with('ARTICLE_82', 'ARTICLE_82_LIBRE', 'ARTICLE_82_PILOTE', () => 'ARTICLE_82')
    .with('PERECOER', 'PERECOER_LIBRE', 'PERECOER_PILOTE', () => 'PERECOER')
    .with('ER_EXTERNAL', () => 'ER_EXTERNAL')
    .exhaustive();
};

export type B2bSavingPlanFamily = 'PEE_FAMILY' | 'PERECO_FAMILY' | B2bSavingPlanCategory;

/**
 * The PASS limit on matching contribution (8% of the PASS for the PEE family, 16% for the PERECO
 * family) is a single legal envelope per family, not per category: a PEE, a PEI and a PEEG all draw
 * on the same 8%. Categories outside those two families keep an envelope of their own.
 */
export const b2bCompanyPlanTypeToPlanFamily = (
  type: B2BPortfolioCompanyPlanType,
): B2bSavingPlanFamily => {
  const category = b2bCompanyPlanTypeToCategory(type);

  if ((B2bPlanCategoryEsPeiValues as readonly B2bSavingPlanCategory[]).includes(category)) {
    return 'PEE_FAMILY';
  }
  if ((B2bPlanCategoryEsPerecoiValues as readonly B2bSavingPlanCategory[]).includes(category)) {
    return 'PERECO_FAMILY';
  }
  return category;
};

// Only the PEE and PERECO families can offer a unilateral matching contribution, whatever the
// contract type. ER plans (PERO, PERU, PER, articles 82 and 83, PERECOER, external ER) cannot.
export const allowsUnilateralMatchingContribution = (category: B2bSavingPlanCategory): boolean =>
  (B2bPlanCategoryEsValues as readonly B2bSavingPlanCategory[]).includes(category);

type NonEmptyArray<T> = [T, ...T[]] & T[];

export function mapPlanCategoryToPlanTypes(
  b2bPlanCategory: B2bSavingPlanCategory,
): NonEmptyArray<B2bSavingPlanType> {
  if (b2bPlanCategory === 'ER_EXTERNAL') {
    return [b2bPlanCategory];
  }

  return [
    mapPlanCategoryToLibrePlanType(b2bPlanCategory),
    mapPlanCategoryToFullyManagedPlanType(b2bPlanCategory),
  ];
}

export function mapERPlanCategoryAndSubtypeToPlanType({
  planCategory,
  subtype,
}: {
  planCategory: Exclude<B2bPlanCategoryEr, 'ER_EXTERNAL'>;
  subtype: 'LIBRE' | 'PILOTE';
}): B2bPlanTypeEr {
  return (
    subtype === 'PILOTE'
      ? mapPlanCategoryToFullyManagedPlanType(planCategory)
      : mapPlanCategoryToLibrePlanType(planCategory)
  ) as B2bPlanTypeEr;
}

export function mapPlanCategoryToFullyManagedPlanType(
  planCategory: B2bSavingPlanCategory,
): B2bSavingPlanType {
  return match(planCategory)
    .returnType<B2bSavingPlanType>()
    .with('PEI', () => 'PEI_PROFILE')
    .with('PEE', () => 'PEE_PROFILE')
    .with('PEEG', () => 'PEEG_PROFILE')
    .with('PERECOI', () => 'PERECOI_PILOTE')
    .with('PERECO', () => 'PERECO_PILOTE')
    .with('PERECOG', () => 'PERECOG_PILOTE')
    .with('PERCOI', () => 'PERCOI_PILOTE')
    .with('PERCO', () => 'PERCO_PILOTE')
    .with('PERO', () => 'PERO_PILOTE')
    .with('PERU', () => 'PERU_PILOTE')
    .with('PER', () => 'PER_PILOTE')
    .with('ARTICLE_82', () => 'ARTICLE_82_PILOTE')
    .with('ARTICLE_83', () => 'ARTICLE_83_PILOTE')
    .with('PERECOER', () => 'PERECOER_PILOTE')
    .with('ER_EXTERNAL', () => 'ER_EXTERNAL')
    .exhaustive();
}

export function mapPlanCategoryToLibrePlanType(
  planCategory: Exclude<B2bSavingPlanCategory, 'ER_EXTERNAL'>,
): B2bSavingPlanType {
  return match(planCategory)
    .returnType<B2bSavingPlanType>()
    .with('PEI', () => 'PEI_LIBRE')
    .with('PEE', () => 'PEE_LIBRE')
    .with('PEEG', () => 'PEEG_LIBRE')
    .with('PERECOI', () => 'PERECOI_LIBRE')
    .with('PERECO', () => 'PERECO_LIBRE')
    .with('PERECOG', () => 'PERECOG_LIBRE')
    .with('PERCOI', () => 'PERCOI_LIBRE')
    .with('PERCO', () => 'PERCO_LIBRE')
    .with('PERO', () => 'PERO_LIBRE')
    .with('PERU', () => 'PERU_LIBRE')
    .with('PER', () => 'PER_LIBRE')
    .with('ARTICLE_82', () => 'ARTICLE_82_LIBRE')
    .with('ARTICLE_83', () => 'ARTICLE_83_LIBRE')
    .with('PERECOER', () => 'PERECOER_LIBRE')
    .exhaustive();
}

export function parsePlanTypeSuffix(name: string): 'LIBRE' | 'PROFILE' | 'PILOTE' | null {
  const lower = name.toLowerCase();

  if (lower.includes('libre')) {
    return 'LIBRE';
  }

  if (lower.includes('profil')) {
    return 'PROFILE';
  }

  if (lower.includes('pilot') || lower.includes('horizon')) {
    return 'PILOTE';
  }

  return null;
}
